"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethod = void 0;
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["AutomatischeIncasso"] = "Automatische incasso";
    PaymentMethod["BetalingPerBank"] = "Betaling per bank";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
//# sourceMappingURL=bank-details.js.map